import React, { useRef, useState } from "react";
import "../assets/styles/App.scss";
import Header from "./parts/Header";
import Kv from "./sections/Kv";
import Separator from "./sections/Separator";
import { StoreProvider } from "./context/Store";
import PersonalData from "./sections/PersonalData";
import ContentWrapper from "./ContentWrapper";
import Photo from "./sections/Photo";
import Preview from "./sections/Preview";
import Education from "./sections/Education";
import Experience from "./sections/Experience";
import Skills from "./sections/Skills";
import Languages from "./sections/Languages";
import Courses from "./sections/Courses";
import About from "./sections/About";
import CvReady from "./sections/CvReady";
import BackToMainPage from "./sections/BackToMainPage";
import useModal from "./hooks/useModal";
import Modal from "./parts/Modal";

import cogs from "../assets/img/cogs.png";

function App() {
  const [paletteModal, togglePaletteModal] = useModal(true);
  const personalRef = useRef<HTMLDivElement>(null);
  const educationRef = useRef<HTMLDivElement>(null);
  const experienceRef = useRef<HTMLDivElement>(null);
  const skillsRef = useRef<HTMLDivElement>(null);
  const languagesRef = useRef<HTMLDivElement>(null);
  const coursesRef = useRef<HTMLDivElement>(null);
  const aboutRef = useRef<HTMLDivElement>(null);
  const cvReadyRef = useRef<HTMLDivElement>(null);
  const printRef = useRef<HTMLDivElement>(null);
  const [cookieModal, setCookieModal] = useState(() =>
    localStorage.getItem("cv-generator-cookies")
  );
  const toggleCookieModal = () => {
    localStorage.setItem("cv-generator-cookies", "true");
    setCookieModal("");
  };
  return (
    <StoreProvider>
      <Header />
      <main>
        <Kv />
        <Separator classes="w-90 mv20" scrollTo={personalRef} />
        <ContentWrapper>
          <div className="row">
            <div className="col-12 col-md-7">
              <PersonalData ref={personalRef} />
              <Photo />
              <Separator scrollTo={educationRef} />
              <Education ref={educationRef} scrollTo={experienceRef} />
              <Separator scrollTo={experienceRef} />
              <Experience ref={experienceRef} scrollTo={skillsRef} />
              <Separator scrollTo={skillsRef} />
              <Skills ref={skillsRef} />
              <Separator scrollTo={languagesRef} />
              <Languages ref={languagesRef} />
              <Separator scrollTo={coursesRef} />
              <Courses ref={coursesRef} />
              <Separator scrollTo={aboutRef} />
              <About ref={aboutRef} scrollTo={cvReadyRef} />
              <Separator scrollTo={cvReadyRef} />
              <CvReady
                paletteModal={paletteModal}
                togglePaletteModal={togglePaletteModal}
                ref={cvReadyRef}
                printRef={printRef}
              />
              <Separator />
              <BackToMainPage />
            </div>
            <div className="col-12 col-md-4 offset-md-1">
              <Preview ref={printRef} />
            </div>
          </div>
        </ContentWrapper>
      </main>
      <Modal open={cookieModal === null} toggle={toggleCookieModal} bottom>
        <div className="cookies">
          <div className="image">
            <img src={cogs} alt="cogs" />
          </div>
          <p>
            Zależy nam, aby świadczyć usługi na najwyższym poziomie. Dlatego
            nasza strona WWW wykorzystuje pliki cookies, które zapisują się w
            pamięci przeglądarki. Pliki cookies (po polsku ciasteczka) to małe
            pliki tekstowe, które automatycznie tworzy przeglądarka internetowa,
            gdy odwiedzasz strony WWW. Informacje w danym pliku cookie może
            odczytać wyłącznie ta strona, z której ten plik pochodzi. Co to
            oznacza dla Ciebie? Strona internetowa nie może mieć dostępu do
            innych plików, które znajdują się na Twoim komputerze. Możesz
            skonfigurować tak swoją przeglądarkę, aby blokowała ona pliki
            cookies lub usuwała je. Więcej na ten temat przeczytasz w naszym
            materiale{" "}
            <a
              target="_blank"
              href="/assets/documents/Polityka cookie.pdf"
              className="blue"
            >
              POLITYKA COOKIES
            </a>
            . Piszemy tam przystępnie także o tym, dlaczego używamy plików
            cookies. Pamiętaj, że jeśli je zablokujesz, nie będziesz mógł,
            niestety, korzystać (całkowicie lub z części funkcji) z naszej
            strony internetowej. Jeśli będziesz dalej korzystać z naszej strony
            i nie zmienisz ustawień plików cookies, uznamy, że zapoznałeś się z
            tą wiadomością i akceptujesz nasze pliki cookies.
          </p>
        </div>
      </Modal>
    </StoreProvider>
  );
}

export default App;

//col-12 col-md-7
//col-12 col-md-4 offset-md-1
